import * as React from 'react';

import SuppliersTable from './SuppliersTable';

export default class Suppliers extends React.Component {
  state = {
    loading: false,
    status: 'pending',
    searchQuery: ''
  };

  public componentDidMount() {
    if ((this.props as any).onCollapse) {
      (this.props as any).onCollapse(false);
    }
  }

  constructor(props: any) {
    super(props);
  }

  public render() {
    return (
      <div>
        <SuppliersTable />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Suppliers/index.tsx